/* tslint:disable */
/* eslint-disable */
/**
 * 160 Digital OS API
 * RESTful API for 160 Digital Operating System
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: it@160driving.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { EnglishTestAnswerDto } from './english-test-answer-dto';

/**
 * 
 * @export
 * @interface EnglishTestQuestionDto
 */
export interface EnglishTestQuestionDto {
    /**
     * 
     * @type {number}
     * @memberof EnglishTestQuestionDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof EnglishTestQuestionDto
     */
    'testId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EnglishTestQuestionDto
     */
    'questionType'?: EnglishTestQuestionDtoQuestionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EnglishTestQuestionDto
     */
    'difficulty'?: EnglishTestQuestionDtoDifficultyEnum;
    /**
     * 
     * @type {string}
     * @memberof EnglishTestQuestionDto
     */
    'questionText'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnglishTestQuestionDto
     */
    'readingPassage'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnglishTestQuestionDto
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnglishTestQuestionDto
     */
    'explanation'?: string;
    /**
     * 
     * @type {number}
     * @memberof EnglishTestQuestionDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof EnglishTestQuestionDto
     */
    'displayOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EnglishTestQuestionDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {Array<EnglishTestAnswerDto>}
     * @memberof EnglishTestQuestionDto
     */
    'answers'?: Array<EnglishTestAnswerDto>;
    /**
     * 
     * @type {string}
     * @memberof EnglishTestQuestionDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnglishTestQuestionDto
     */
    'updatedAt'?: string;
}

export const EnglishTestQuestionDtoQuestionTypeEnum = {
    MultipleChoice: 'MULTIPLE_CHOICE',
    TrueFalse: 'TRUE_FALSE',
    FillInBlank: 'FILL_IN_BLANK',
    Matching: 'MATCHING',
    ReadingComprehension: 'READING_COMPREHENSION'
} as const;

export type EnglishTestQuestionDtoQuestionTypeEnum = typeof EnglishTestQuestionDtoQuestionTypeEnum[keyof typeof EnglishTestQuestionDtoQuestionTypeEnum];
export const EnglishTestQuestionDtoDifficultyEnum = {
    Easy: 'EASY',
    Medium: 'MEDIUM',
    Hard: 'HARD'
} as const;

export type EnglishTestQuestionDtoDifficultyEnum = typeof EnglishTestQuestionDtoDifficultyEnum[keyof typeof EnglishTestQuestionDtoDifficultyEnum];


